import React from 'react';
import PropTypes from 'prop-types';
import {formatDate} from 'common/formatters/date-formatter';
import {DateTimeFormat} from 'common/proxies/enum-proxy';
import SvgText from 'components/svg-text';
import {getTranslate} from 'utils/attribute-util';
import Colors from 'common/constants/colors';
import styles from './index.css';

export default class HeatmapMonthAxis extends React.Component {
  static propTypes = {
    gutters: PropTypes.object,
    months: PropTypes.array,
    rowHeight: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    gutters: {},
    months: [],
    rowHeight: 0,
    y: 0,
  };

  getDividerPositionsY(monthHeights) {
    const dividerPositionsY = [];
    monthHeights.forEach((monthHeight, index) => {
      const previous = dividerPositionsY[index - 1];
      if (previous) {
        dividerPositionsY.push(monthHeight + previous);
      } else {
        dividerPositionsY.push(monthHeight);
      }
    });

    // We want a divider at zero too:
    dividerPositionsY.unshift(0);

    return dividerPositionsY;
  }

  getLabelPositionsY(monthHeights, dividerPositionsY) {
    return monthHeights.map(
      (monthHeight, index) => dividerPositionsY[index] + monthHeight / 2,
    );
  }

  getLabels(months, monthHeights) {
    return months.map((month, index) => {
      // If there are 30 pixels or less, there really isn't
      // room for anything, so let's return an empty string.
      if (monthHeights[index] < 30) {
        return '';
      }
      return formatDate(month.timestamp, DateTimeFormat.MONTH);
    });
  }

  getMonthHeights(months, rowHeight) {
    return months.map((month) => rowHeight * month.days.length);
  }

  render() {
    const monthHeights = this.getMonthHeights(
      this.props.months,
      this.props.rowHeight,
    );
    const dividerPositionsY = this.getDividerPositionsY(monthHeights);
    const labelPositionsY = this.getLabelPositionsY(
      monthHeights,
      dividerPositionsY,
    );
    const labels = this.getLabels(this.props.months, monthHeights);
    return (
      <g
        className={styles.HeatmapMonthAxis}
        transform={getTranslate(0, this.props.y)}>
        {dividerPositionsY.map((posY, index) => (
          <line
            key={index}
            stroke={Colors.gray300}
            strokeOpacity={1}
            x1={0}
            x2={this.props.gutters.left}
            y1={posY}
            y2={posY}
          />
        ))}

        {labelPositionsY.map((posY, index) => (
          <SvgText
            key={index}
            text={labels[index]}
            transform={`rotate(270, 0, ${posY})`}
            y={
              /* the label aligns better with a small offset */
              posY + 3
            }
          />
        ))}
      </g>
    );
  }
}
